module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "online_complaints"
  }, [_c('ul', {
    staticStyle: {
      "background-color": "#fff",
      "padding": "0 0.2rem"
    }
  }, [_c('li', [_c('span', {
    staticClass: "fl complaints_fixed complaints_tel"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "fl"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userTel),
      expression: "userTel"
    }],
    attrs: {
      "placeholder": "请输入手机号",
      "type": "number",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.userTel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userTel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.selectResponsibleParty
    }
  }, [_c('span', {
    staticClass: "fl complaints_fixed complaints_reason"
  }, [_vm._v("投诉对象")]), _vm._v(" "), (_vm.responsible.responsibleParty == null || _vm.responsible.responsibleParty == '' || _vm.responsible.responsibleParty == undefined) ? _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fl select-item"
  }, [_vm._v(_vm._s(_vm.responsible.responsibleParty))]), _c('span', {
    staticClass: "fr icon_arrow_down"
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.selectReason
    }
  }, [_c('span', {
    staticClass: "fl complaints_fixed complaints_reason"
  }, [_vm._v("投诉理由")]), _vm._v(" "), (_vm.responsible.responsibleParty == null || _vm.responsible.responsibleParty == '' || _vm.responsible.responsibleParty == undefined) ? _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fl select-item"
  }, [_vm._v(_vm._s(_vm.reason.reasonDesc))]), _c('span', {
    staticClass: "fr icon_arrow_down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complaints_des_box"
  }, [_c('h3', {
    staticClass: "complaints_des"
  }, [_vm._v("详细描述")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "name": "",
      "id": "complaints_con",
      "maxlength": "200",
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }, _vm.descInput]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.remnant) + "/200")])]), _vm._v(" "), _c('div', {
    staticClass: "addPicBox"
  }, [_c('div', {
    staticClass: "addimg_tips"
  }, [_vm._v("上传凭证处理更快（不超过3张）")]), _vm._v(" "), _c('div', {
    staticClass: "addPic"
  }, [_c('ul', {
    staticClass: "fl"
  }, _vm._l((_vm.goodsImages), function(item, index) {
    return _c('li', {
      staticClass: "fl upLoadPic"
    }, [_c('div', {
      style: ({
        backgroundImage: 'url(' + item + ')'
      })
    }), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.deletepic(index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddShow),
      expression: "isAddShow"
    }],
    staticClass: "addPicBtn fl"
  }, [_c('form', {
    attrs: {
      "id": "uploadForm",
      "method": "post",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "uploadImg",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.getImage($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "goodsList"
  }, [_c('div', {
    staticClass: "shopName arrow-right ellipse"
  }, [_vm._v(_vm._s(_vm.shopName))]), _vm._v(" "), _c('ul', _vm._l((_vm.goodsList), function(item) {
    return _c('li', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('img', {
      staticClass: "shopPic",
      attrs: {
        "src": item.picAddr
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodsName flexcol",
      staticStyle: {
        "width": "60%",
        "height": "100%",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "ellipse",
      staticStyle: {
        "width": "60%",
        "color": "#333",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#9B9B9B"
      }
    }, [_vm._v("x" + _vm._s(item.number))])])]), _vm._v(" "), _c('div', {
      staticClass: "goodsPri"
    }, [_vm._v("￥ " + _vm._s(item.salePrice))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "btn submit_btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag1),
      expression: "flag1"
    }],
    staticClass: "complaints_reason_select",
    on: {
      "click": function($event) {
        return _vm.hiddenList(1)
      }
    }
  }, [_c('ul', _vm._l((_vm.responsiblePartyList), function(item, index) {
    return _c('li', {
      ref: "menuItem",
      refInFor: true,
      staticClass: "reason_list",
      class: {
        on: item.isDefault == 1
      },
      on: {
        "click": function($event) {
          return _vm.handleClick1(item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.responsibleParty))]), _c('span', {
      staticClass: "icon_selected"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag),
      expression: "flag"
    }],
    staticClass: "complaints_reason_select",
    on: {
      "click": function($event) {
        return _vm.hiddenList(2)
      }
    }
  }, [_c('ul', _vm._l((_vm.reasonList), function(item, index) {
    return _c('li', {
      ref: "menuItem",
      refInFor: true,
      staticClass: "reason_list",
      class: {
        on: item.isDefault == 1
      },
      on: {
        "click": function($event) {
          return _vm.handleClick(item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.reasonDesc))]), _c('span', {
      staticClass: "icon_selected"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "telComplaint"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.tel
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4d6c27b9","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/OnlineComplaints.vue
// module id = 438
// module chunks = 7